import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { pluck, pluckNumber } from '../../../../fc-core/src/lib';
import { trim } from '../utils';
import AnnotationShape from './annotation-shape';

function getCharacterType(a) {
  return '9' >= a && '0' <= a || '-' === a || '.' === a ? 0 : 'z' >= a && 'a' <= a || 'Z' >= a && 'A' <= a ? 1 : 2;
}

var PathAnnotation =
/*#__PURE__*/
function (_AnnotationShape) {
  _inherits(PathAnnotation, _AnnotationShape);

  function PathAnnotation() {
    _classCallCheck(this, PathAnnotation);

    return _possibleConstructorReturn(this, _getPrototypeOf(PathAnnotation).apply(this, arguments));
  }

  _createClass(PathAnnotation, [{
    key: "getName",
    value: function getName() {
      return 'path';
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(PathAnnotation.prototype), "configureAttributes", this).call(this, a);

      var b = this,
          c = b.rawConfig;
      b.config.pathStr = pluck(c.path), b.config.x = pluckNumber(c.x, 0), b.config.y = pluckNumber(c.y, 0), b.config.tox = pluckNumber(c.toX, b.config.x), b.config.toy = pluckNumber(c.toY, b.config.y), b.config.elementType = 'path';
    }
  }, {
    key: "getScaledPath",
    value: function getScaledPath() {
      var a,
          b,
          c,
          d,
          e,
          f = this,
          g = f.config.pathStr,
          h = [],
          k = '';

      for (e = g && g.length, c = 0; c < e; c++) {
        for (d = c, b = '', a = getCharacterType(g[c]); d < e && getCharacterType(g[d]) === a;) {
          b += g[d], d++;
        }

        b = trim(b), '' !== b && 2 > a && h.push(b), c = d === c ? d : d - 1;
      }

      for (e = h.length, c = 0; c < e;) {
        switch (k += h[c], h[c].toLowerCase()) {
          case 'm':
          case 'l':
          case 't':
            k += f.getScaledVal(+h[c + 1], !0).toString() + ',', k += f.getScaledVal(+h[c + 2], !1).toString(), c += 3;
            break;

          case 's':
          case 'q':
            k += f.getScaledVal(+h[c + 1], !0).toString() + ',', k += f.getScaledVal(+h[c + 2], !1).toString() + ',', k += f.getScaledVal(+h[c + 3], !0).toString() + ',', k += f.getScaledVal(+h[c + 4], !1).toString(), c += 5;
            break;

          case 'h':
            k += f.getScaledVal(+h[c + 1], !0).toString(), c += 2;
            break;

          case 'v':
            k += f.getScaledVal(+h[c + 1], !1).toString(), c += 2;
            break;

          case 'c':
            k += f.getScaledVal(+h[c + 1], !0).toString() + ',', k += f.getScaledVal(+h[c + 2], !1).toString() + ',', k += f.getScaledVal(+h[c + 3], !0).toString() + ',', k += f.getScaledVal(+h[c + 4], !1).toString() + ',', k += f.getScaledVal(+h[c + 5], !0).toString() + ',', k += f.getScaledVal(+h[c + 6], !1).toString(), c += 7;
            break;

          case 'a':
            k += f.getScaledVal(+h[c + 1], !0).toString() + ',', k += f.getScaledVal(+h[c + 2], !1).toString() + ',', k += f.getScaledVal(+h[c + 3], !0).toString() + ',', k += h[c + 4] + ',', k += h[c + 5] + ',', k += f.getScaledVal(+h[c + 6], !0).toString() + ',', k += f.getScaledVal(+h[c + 7], !1).toString(), c += 8;
            break;

          case 'z':
          default:
            c++;
        }
      }

      return k.toString();
    }
  }, {
    key: "updateAttr",
    value: function updateAttr() {
      var a,
          b,
          c,
          d,
          e = this,
          f = e.config,
          g = f.calculatedAttrs,
          h = {};
      a = pluckNumber(g.x, e.getScaledVal(f.x, !0)), b = pluckNumber(g.y, e.getScaledVal(f.y, !1)), c = pluckNumber(g.toX, a, e.getScaledVal(f.tox, !0)), d = pluckNumber(g.toY, b, e.getScaledVal(f.toy, !1)), f.pathStr ? (h.path = e.getScaledPath(), h.transform = "T".concat(a, ",").concat(b)) : h.path = "M".concat(a, ",").concat(b, "L").concat(c, ",").concat(d), e._setConfig('attr', h);
    }
  }, {
    key: "_getAnnotationAttrs",
    value: function _getAnnotationAttrs() {
      var a,
          b,
          c,
          d,
          e,
          f = this,
          g = f.config,
          h = f._getConfig('attr') || {},
          i = g.borderThickness,
          j = g.dashArrayStr,
          k = g.color;
      return (h.stroke = k, f.rawConfig.color && (h.fill = k), h['stroke-width'] = f.getScaledVal(i), h['stroke-dasharray'] = j, a = h.x || f.getScaledVal(g.x, !0), b = h.y || f.getScaledVal(g.y, !1), c = h.toX || f.getScaledVal(g.tox, !0), d = h.toY || f.getScaledVal(g.toy, !1), h.path) ? h : (e = f.getScaledPath(), e ? (h.path = e, h.transform = h.transform || "T".concat(a, ",").concat(b)) : h.path = h.path || "M".concat(a, ",").concat(b, "L").concat(c, ",").concat(d), h);
    }
  }]);

  return PathAnnotation;
}(AnnotationShape);

export default PathAnnotation;